import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { QueryClientProvider } from '@tanstack/react-query';
import { App } from './App';
import { queryClient } from './lib/board';
import { hydrateOffline } from './lib/offline';
import { initOfflineSync, startOutbox } from './lib/offlineSync';
import './index.css';

initOfflineSync();

// Letzten Stand vom Gerät einsetzen (offline lesen), dann rendern – höchstens kurz warten (0.44)
void hydrateOffline(queryClient)
  .catch(() => null)
  .then((acc) => {
    if (acc) void startOutbox(acc);
    createRoot(document.getElementById('root')!).render(
      <StrictMode>
        <QueryClientProvider client={queryClient}>
          <App />
        </QueryClientProvider>
      </StrictMode>,
    );
  });
